
import { useQuery } from '@tanstack/react-query';
import { systemSettingsService } from '@/services/systemSettingsService';
import { serviceLogger } from '@/utils/debug';

export const usePortalStatus = () => {
  const { data: isPortalActive, isLoading, error } = useQuery({
    queryKey: ['portal-status'],
    queryFn: async () => {
      try {
        serviceLogger.log('🔥 Fetching portal status from database');
        const setting = await systemSettingsService.getSetting('is_portal_active');
        serviceLogger.log('🔥 Raw portal setting value:', setting);
        
        // Parse the JSON value and default to true if not found
        let parsedValue = true; // Default to active
        
        if (setting !== null) {
          try {
            parsedValue = typeof setting === 'string' ? JSON.parse(setting) : setting;
          } catch (parseError) {
            serviceLogger.error('🔥 Error parsing portal status:', parseError);
            serviceLogger.captureError(parseError);
            // If parsing fails, treat as boolean directly
            parsedValue = Boolean(setting);
          }
        }
        
        serviceLogger.log('🔥 Parsed portal status:', parsedValue);
        return parsedValue;
      } catch (error) {
        serviceLogger.error('🔥 Error fetching portal status:', error);
        serviceLogger.captureError(error);
        return true; // Default to active if there's an error
      }
    },
    refetchInterval: 30000, // Check every 30 seconds
    retry: 1, // Only retry once on failure
  });

  serviceLogger.log('🔥 usePortalStatus hook state:', { 
    isPortalActive, 
    isLoading, 
    error: error?.message 
  });

  return {
    isPortalActive: isPortalActive ?? true, // Default to true
    isLoading: isLoading || false,
    error
  };
};
